import React from 'react';
import styled from 'styled-components';
import Multiselect from 'multiselect-react-dropdown';

const Wrapper = styled.div`
  width: ${({ width }) => width || '100%'};
  min-height: ${({ height }) => height || 'auto'};
  //   background-color: ${({ dropdownBg }) => dropdownBg || '#f9f9f9'};
  border-radius: 0px;
  // padding: 5px;

  .multiselect-container {
    background-color: transparent !important;
    // border: none !important;
    box-shadow: none !important;
    border: ${(props) =>
      props.errorText ? '1px solid red' : 'none !important'};
  }

  /* Make dropdown options background transparent */
  .multiselect-container .optionContainer {
    background-color: transparent !important;
    border: none !important;
  }

  /* Remove background on all list items (options) */
  .multiselect-container .optionContainer li {
    background-color: transparent !important;
    color: #000 !important; /* or your desired text color */
    height: 40px;
  }

  .multiselect-container .optionContainer li:hover {
    background-color: #fff2f8 !important;
    color: #911e59 !important;
  }

  .multiselect-container .searchBox {
    border: none !important;
    background: transparent !important;
    min-height: 40px;
    padding: 6px 10px;
    font-size: 14px;
  }

  .multiselect-container .searchWrapper {
    // border: 1px solid #ccc;
    border: ${(props) =>
      props.errorText ? 'none !important' : '1px solid #ccc'};
    border-radius: 0px;
    padding: 2px;
    position: relative;
    min-height: 50px;
  }

  .multiselect-container .searchWrapper.option__chip {
    background-color: ${({ chipBg }) => chipBg || '#3b82f6'};
    color: white;
    padding: 5px 10px;
    border-radius: 12px;
    margin: 5px 5px 0 0;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
  }

  .multiselect-container.option__chip span {
    margin-left: 8px;
    cursor: pointer;
    font-weight: bold;
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 16px;
  color: #ee3232;
  line-height: 24px;
  font-weight: 400;
  font-family: Akkurat;
  margin-top: 5px;
  position: absolute;
  bottom: -30px;
`;

const MultiSelectChip = ({
  options,
  onSelect,
  value,
  onSearch,
  onRemove,
  height,
  width,
  dropdownBg,
  chipBg,
  ...props
}) => {
  const handleKeyPress = () => {};

  const formattedOptionsData = Array.isArray(options)
    ? options.map((item) => ({
        ...item,
        displayName:
          item?.title ||
          item?.name?.name_en ||
          item?.name_en ||
          (typeof item?.name === 'string' ? item.name : '') ||
          '',
      }))
    : [];

  const formattedSelectedValues = Array.isArray(value)
    ? value.map((item) => ({
        ...item,
        displayName:
          item?.title ||
          item?.name?.name_en ||
          item?.name_en ||
          (typeof item?.name === 'string' ? item.name : '') ||
          '',
      }))
    : [];

  return (
    <div className="relative">
      <Wrapper
        height={height}
        width={width}
        dropdownBg={dropdownBg}
        chipBg={chipBg}
        {...props}
      >
        <Multiselect
          options={formattedOptionsData}
          displayValue="displayName"
          selectedValues={formattedSelectedValues}
          onKeyPressFn={handleKeyPress}
          onRemove={onRemove}
          onSearch={onSearch}
          onSelect={onSelect}
          showCheckbox
        />
      </Wrapper>

      {props.errorText && <WrapperErrorDiv>{props.errorText}</WrapperErrorDiv>}
    </div>
  );
};

export default MultiSelectChip;
